import React, { useState } from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { eventSocialService } from '../services/friendsService';

const LikeButton = ({ eventId, initialLikes = [], currentUserId, onLikeChange }) => {
    const [likes, setLikes] = useState(initialLikes);
    const [loading, setLoading] = useState(false);
    
    const isLiked = likes.some(like => like.user === currentUserId || like.user?._id === currentUserId);
    const likesCount = likes.length;

    const handleToggleLike = async (e) => {
        e.stopPropagation(); // Prevent event bubbling
        
        if (!currentUserId) return;
        
        setLoading(true);
        try {
            if (isLiked) {
                await eventSocialService.unlikeEvent(eventId);
                const newLikes = likes.filter(like => 
                    like.user !== currentUserId && like.user._id !== currentUserId
                );
                setLikes(newLikes);
                onLikeChange?.(newLikes.length);
            } else {
                await eventSocialService.likeEvent(eventId);
                const newLike = {
                    user: currentUserId,
                    likedAt: new Date().toISOString()
                };
                const newLikes = [...likes, newLike];
                setLikes(newLikes);
                onLikeChange?.(newLikes.length);
            }
        } catch (error) {
            if (process.env.NODE_ENV === 'development') console.error('Error toggling like:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            onClick={handleToggleLike}
            disabled={loading || !currentUserId}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-all duration-300 ${
                isLiked
                    ? 'bg-red-500/20 text-red-400 hover:bg-red-500/30'
                    : 'bg-white/10 text-gray-300 hover:bg-white/20 hover:text-red-400'
            } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
            {loading ? (
                <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
            ) : (
                isLiked ? <FaHeart className="text-red-500" /> : <FaRegHeart />
            )}
            <span className="text-sm">{likesCount}</span>
        </button>
    );
};

export default LikeButton;